__turbopack_context__.v({
  "message": "index-module__U1f2Ha__message",
  "root": "index-module__U1f2Ha__root",
});
